import { Box, Chip, Grid, Typography } from '@mui/material';

const ScoreBox = ({ label, value }) => {
  const getPerformanceLabel = (value) => {
    if (value <= 3) return { label: 'Below Performance', color: '#f57c00' };
    if (value <= 6) return { label: 'Good Performance', color: '#81c784' };
    if (value <= 8) return { label: 'Very Good', color: '#4caf50' };
    return { label: 'Excellent', color: '#2e7d32' };
  };

  const { label: performanceLabel, color } = getPerformanceLabel(parseInt(value));
  return (
    <Grid item xs={12} sm={6}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: '#f9fafb',
          p: 1.5,
          borderRadius: 2,
          mb: 1,
        }}
      >
        <Typography variant="body2">{label}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {value}
          </Typography>
          <Chip
            label={performanceLabel}
            sx={{
              backgroundColor: color,
              color: '#fff',
              fontSize: '0.75rem',
              height: 22,
            }}
          />
        </Box>
      </Box>
    </Grid>
  );
};

export default ScoreBox;
